import { RVEnvironment, RVPicketItem, SearchOption } from "../../../api/entities";
import { Property } from "../../../api/Property";
import { LocaleUtil } from "@eres/core";
import { PickerItemFormatter } from "@my-dld/components/Form/PickerInput";
import { RVLookupX } from "../../../api/api";
import { ErrorContainer } from "@eres/forms";

export interface FormProps {
	env: RVEnvironment;
	searchType?: RVPicketItem;//RVSearchType;
}

export interface FormState {
	errorContainer: ErrorContainer;
}


export interface IPForm {
	updateParams( opts: SearchOption, env: RVEnvironment ): void;

	validate( opts: SearchOption, env: RVEnvironment ): boolean;
}

interface PickerItemSelector {
	selectItem: ( items: any[], selector: any ) => any;
	toSelector: ( item: any ) => any;
}

export const LandPickerItemFormatter: PickerItemFormatter<Property> = ( item: Property ) => {
	let landNumber = item.LandNo;
	if ( item.LandSubNo && item.LandSubNo !== "0" ) {
		landNumber = landNumber + "-" + item.LandSubNo;
	}
	return landNumber;
};

export const LandPickerItemSelector: PickerItemSelector = {
	selectItem( items: Property[], selector: any ) {
		return items.find( value => LandPickerItemFormatter( value ) + "" === selector + "" );
	},
	toSelector( item: Property ) {
		return LandPickerItemFormatter( item );
	},
};

export const BuildingPickerItemFormatter: PickerItemFormatter<Property> = ( item: Property ) => {
	return LocaleUtil.getLocalValue( {
		en: item.BuildingNameEn,
		ar: item.BuildingNameAr,
	} );
};

export const BuildingPickerItemSelector: PickerItemSelector = {
	selectItem( items: Property[], selector: any ) {
		return items.find( value => value.BuildingPropertyId + "" === selector + "" );
	},
	toSelector( item: Property ) {
		return item.BuildingPropertyId + "";
	},
};

export function sortRVXLookups( source: RVLookupX[] ) {
	return source?.sort( function ( a, b ) {
		const first = LocaleUtil.getLocalValue( a ) || "";
		const second = LocaleUtil.getLocalValue( b ) || "";
		return first.toLowerCase().localeCompare( second.toLowerCase() );
	} );
}
